import React from 'react';
import { education, certifications } from '../../data/constants';
import useReveal from '../../hooks/useReveal';
import './styles.css';

export default function Education() {
  const ref = useReveal();

  return (
    <section className="section" id="education" ref={ref}>
      <p className="section-label reveal">Education & Certs</p>
      <h2 className="section-title reveal reveal-delay-1">Background</h2>

      <div className="edu__layout">
        {/* Education timeline */}
        <div className="edu__timeline reveal reveal-delay-2">
          <h3 className="edu__heading">Education</h3>
          {education.map((edu, i) => (
            <div className="edu__item" key={i}>
              <div className="edu__dot-line">
                <div className="edu__dot" />
                {i < education.length - 1 && <div className="edu__line" />}
              </div>
              <div className="edu__card">
                <div className="edu__card-header">
                  {edu.logo && <img src={edu.logo} alt="" className="edu__logo" />}
                  <div>
                    <h4 className="edu__school">{edu.school}</h4>
                    <p className="edu__degree">{edu.degree}</p>
                  </div>
                </div>
                <div className="edu__meta">
                  <span className="edu__date">{edu.date}</span>
                  {edu.grade && <span className="edu__grade">{edu.grade}</span>}
                </div>
                <p className="edu__desc">{edu.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Certifications */}
        <div className="edu__certs reveal reveal-delay-3">
          <h3 className="edu__heading">Certifications</h3>
          {certifications.map((cert, i) => (
            <div className="cert__card" key={i}>
              <div className="cert__icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                </svg>
              </div>
              <div>
                <h4 className="cert__title">{cert.title}</h4>
                <p className="cert__issuer">{cert.issuer}</p>
                <span className="cert__year">{cert.year}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
